import axios from "axios";

function normalizeApiBaseUrl(input) {
  let v = String(input || "").trim();
  if (!v) return "";

  if (!/^https?:\/\//i.test(v)) {
    const proto = process.env.NODE_ENV === "production" ? "https" : "http";
    v = `${proto}://${v}`;
  }

  v = v.replace(/\/+$/, "");

  if (
    typeof window !== "undefined" &&
    window.location?.protocol === "https:" &&
    v.startsWith("http://")
  ) {
    v = `https://${v.slice("http://".length)}`;
  }

  return v;
}

const API_BASE_URL = normalizeApiBaseUrl(
  process.env.REACT_APP_API_BASE_URL || "http://localhost:8080"
);

if (
  process.env.NODE_ENV === "production" &&
  (!process.env.REACT_APP_API_BASE_URL ||
    /localhost|127\.0\.0\.1/i.test(API_BASE_URL))
) {
  console.error(
    "[config] Production build should set REACT_APP_API_BASE_URL to your API origin (e.g. https://api.example.com), not localhost."
  );
}

const api = axios.create({
  baseURL: `${API_BASE_URL}/api`,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

export default api;
